import { Injectable, inject } from '@angular/core';
import { UiNotificationService } from '../../ui/ui-notification/ui-notification.service';
import { BehaviorSubject, combineLatest, EMPTY, NEVER, Observable, of, take } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslocoService } from '@ngneat/transloco';
import * as Sentry from '@sentry/angular-ivy';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private readonly notificationsService = inject(UiNotificationService);
  private readonly translocoService = inject(TranslocoService);

  handleError(err: ErrorEvent | HttpErrorResponse, loadingSource?: BehaviorSubject<boolean>, listMode = false): Observable<any> {
    let customData;
    try {
      customData = JSON.parse(err?.error);
    } catch (err) {
      //  do nothing
    }
    const message = customData?.message || err?.error?.message || err?.message || err;
    Sentry.captureException(message);
    loadingSource.next(false);

    combineLatest(
      this.translocoService.selectTranslate('common.error.title').pipe(take(1)),
      this.translocoService.selectTranslate('common.error.message').pipe(take(1))
    )
      .pipe(
        take(2),
        tap(([commonTitle, commonMessage]) => this.notificationsService.showError(commonTitle, message || commonMessage))
      )
      .subscribe();

    return listMode ? of([]) : NEVER;
  }

  handleStoreError(err: HttpErrorResponse): void {
    let customData;
    try {
      customData = JSON.parse(err?.error);
    } catch (err) {
      //  do nothing
    }
    if (err.status === 403 && (err.error.error === 'Insufficient permissions' || err.error.error === 'Permissions not found')) {
      return this.notificationsService.showError('Error', err.error.error);
    }
    const message = customData?.message || err?.error?.message || err?.message || err;
    Sentry.captureException(message);

    combineLatest(
      this.translocoService.selectTranslate('common.error.title').pipe(take(1)),
      this.translocoService.selectTranslate('common.error.message').pipe(take(1))
    )
      .pipe(
        take(2),
        tap(([commonTitle, commonMessage]) => this.notificationsService.showError(commonTitle, message || commonMessage))
      )
      .subscribe();
  }
}
